import { render, staticRenderFns } from "./gVerify.vue?vue&type=template&id=2b60ad7c&"
import script from "./gVerify.vue?vue&type=script&lang=js&"
export * from "./gVerify.vue?vue&type=script&lang=js&"
import style0 from "./gVerify.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports